export default "__VITE_ASSET__DK1bJxvD__"